import { RobotApi } from 'api/RobotApi'
import { StationApi } from 'api/StationApi'
import Loader from 'components/Loader/Loader'
import { useEffectOnce } from 'hooks/useEffectOnce'
import { useState } from 'react'
import { PROGRESS_TYPES } from 'utils/constants'
import { ROBOT_NETWORK_STATUSES } from 'utils/constants'
import { ILot, IRobotInfo, IStation } from 'utils/interfaces'

import StationListView from './StationListView/StationListView'

const StationList = () => {
  const [loadingProgress, setLoadingProgress] = useState(PROGRESS_TYPES.IDLE)
  const [robots, setRobots] = useState<IRobotInfo[]>([])
  const [stations, setStations] = useState<IStation[]>([])
  const [lots, setLots] = useState<ILot[]>([])

  const fetchData = async () => {
    try {
      setLoadingProgress(PROGRESS_TYPES.WORK)
      const robotsResult = await RobotApi.fetchRobots()
      setRobots(robotsResult.results)
      const stations = await StationApi.fetchStations()
      setStations(stations)
      const lots = await StationApi.fetchLots()
      setLots(lots)
      setLoadingProgress(PROGRESS_TYPES.SUCCESS)
    } catch (error) {
      // Silently handle network errors (ERR_NETWORK_CHANGED, Failed to fetch, etc.)
      // These are common when network connection is unstable and don't need user attention
      if (error instanceof TypeError && error.message === 'Failed to fetch') {
        // Network error - don't set ERROR state, keep current state or reset to IDLE
        // User can retry by refreshing the page
        setLoadingProgress(PROGRESS_TYPES.IDLE)
        return
      }
      // For other errors, set error state
      setLoadingProgress(PROGRESS_TYPES.ERROR)
      console.warn('[StationList] fetchData error:', error)
    }
  }

  const fetchStations = async () => {
    const stations = await StationApi.fetchStations()
    setStations(stations)
  }

  useEffectOnce(() => {
    fetchData()
  })

  if (loadingProgress === PROGRESS_TYPES.WORK || loadingProgress === PROGRESS_TYPES.IDLE) return <Loader />
  if (loadingProgress === PROGRESS_TYPES.ERROR) return <div>Error</div>

  return (
    <StationListView
      stations={stations.sort((a, b) => b.id - a.id)}
      robots={robots}
      lots={lots}
      onStationsUpdated={fetchData}
      onStationsChanged={fetchStations}
    />
  )
}

export default StationList
